module.exports = __webpack_public_path__ + "static/media/feature1.693e8f39.png";